import { ajaxRequest } from 'app/utils/helpers';
import { NO_RESULTS } from './noResultsConstants';

const { noSearchResultsUrl } = window.inlinePlp || {};

export const noResults = template => ({
  type: NO_RESULTS,
  template,
});

export const fetchNoResults = () => dispatch =>
  ajaxRequest('GET', noSearchResultsUrl).then(
    html => dispatch(noResults(html)),
    () => dispatch(noResults(''))
  );
